__turbopack_context__.v({
  "snapCarousel": "SnapCarousel-module-scss-module__6LQPNG__snapCarousel",
});
